export const transactionStatusText = {
    1: '',
    2: 'E-Consult',
    3: 'Refunded to Wallet',
    4: '',
    5: 'Wallet Recharge',
    6: '',
    7: 'Payment Failed',
    8: 'Payment Reversed',
    9: 'Payment in Progress',
    10: 'Payment Reversal in Progress',
    11: '',
    12: '',
    13: 'Sehat Sikke on Registration',
    14: 'Sehat Sikke on Referral',
    15: 'Cashback on E-Consult',
    16: 'Cashback on Follow-Up',
    17: 'Sehat Sikke Expired',
    18: '',
    19: 'Sehat Sikke on Activity',
    20: 'Sehat Sikke on Service',
    21: '',
    22: 'Sehat Sikke Refund',
    23: 'Coupon Purchase',
    45: 'Sehat Sikke on Referral'    
}